/* eslint-disable */
import React, { Component } from "react";
import { Form, Button, Grid, Input } from "semantic-ui-react";
import { selectFieldStyle, selectFieldStyleError } from "@utils/const";
import ErrorMsgLabel from "../shared/errorMsgLabel";
// import { DateInput } from 'semantic-ui-calendar-react';
import _ from "lodash";
import Select from "react-select";
import CustomSnackbar from "../shared/custom_snackbar";
import {
  
  getTodayDate,
  lastDayOfTheMonth,
  getFirstDayOfTheMonth,
  reverseMaskDate,
  dateDividers,
} from "@utils/date";
import m from "@utils/strings";
import "@styles/geracao-lote-cobranca.css";

class FormFiltro extends Component {
  constructor(props) {
    super(props);

    this.tiposGuia = [{ value: "CONSULTA", label: "CONSULTA" }];

    this.state = {
      dateRange: "",
      dateFrom: reverseMaskDate(getFirstDayOfTheMonth()),
      dateTo: reverseMaskDate(getTodayDate()),
      tipoGuia: { value: "CONSULTA", label: "CONSULTA" },
      isDateFromValid: true,
      isDateToValid: true,
      snackBarMessage: "",
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.props.focusFirstField(this.focus);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
  }

  handleKeyDown(event) {
    if (
      event.key === "Enter" &&
      this.props.activeAccordion == "1" &&
      !this.props.isModalOpened
    ) {
      event.preventDefault();
      this.handleSubmit();
    }
  }

  dateChange = (event, { name, value }) => {
    

    let temp = reverseMaskDate(value, dateDividers.DASH, dateDividers.BAR);
    let splitDate = temp.split("/");

    if (splitDate.length === 3) {
      if (parseInt(splitDate[1], 10) > 12) splitDate[1] = "1";
      if (
        splitDate[1].length > 0 &&
        parseInt(splitDate[0], 10) >
          lastDayOfTheMonth(parseInt(splitDate[1], 10))
      )
        splitDate[0] = "1";
      if (splitDate[2].length <= 4) {
        // value = splitDate[0] + "/" + splitDate[1] + "/" + splitDate[2];
        this.setState({ [name]: value });
      }
      if (
        splitDate[2].length === 4 &&
        new Date(`${splitDate[1]}/${splitDate[0]}/${splitDate[2]}`) > new Date()
      ) {
        this.setState({
          snackBarMessage:
            m.TELA_GERACAO_LOTE_COBRANCA.NOTIFICACAO_DATA_INVALIDA,
        });
        this.exibirSnackBar();
        this.setState({ [name]: reverseMaskDate(getTodayDate()) });
      }
    } else if (splitDate.length > 3) {
    } else {
      this.setState({ [name]: value });
    }

    if (name == "dateFrom")
      if (!this.isDateValid(splitDate)) {
        this.setState({ isDateFromValid: false });
      } else {
        this.setState({ isDateFromValid: true });
      }
    else if (name == "dateTo")
      if (!this.isDateValid(splitDate)) {
        this.setState({ isDateToValid: false });
      } else {
        this.setState({ isDateToValid: true });
      }

    let formattedDateFrom = reverseMaskDate(this.state.dateFrom, dateDividers.DASH, dateDividers.BAR).split("/");
    let formattedDateTo = reverseMaskDate(this.state.dateTo, dateDividers.DASH, dateDividers.BAR).split("/");

    let tempDateFrom = new Date(
      `${formattedDateFrom[1]}/${formattedDateFrom[0]}/${formattedDateFrom[2]}`
    );
    let tempDateTo = new Date(
      `${formattedDateTo[1]}/${formattedDateTo[0]}/${formattedDateTo[2]}`
    );

    if (tempDateFrom > tempDateTo) {
      this.setState({
        snackBarMessage:
          m.TELA_GERACAO_LOTE_COBRANCA
            .NOTIFICACAO_DATA_INICIAL_MAIOR_DATA_FINAL,
      });
      this.exibirSnackBar();
      this.setState({ dateFrom: this.state.dateTo });
    }
  };

  isDateValid = (date) => {
    if (date.length == 1 && _.isEmpty(date[0])) return true;
    if (_.isEmpty(date)) return true;
    if (
      date.length != 3 ||
      date[1].length === 0 ||
      date[0].length === 0 ||
      date[2].length === 0
    )
      return false;
    if (
      new Date(`${date[1]}/${date[0]}/${date[2]}`).toString() === "Invalid Date"
    )
      return false;
    return true;
  };

  handleInputStateValue = (event) => {
    this.setState({ tipoGuia: event });
  };

  handleSubmit = () => {
    let from = reverseMaskDate(this.state.dateFrom, dateDividers.DASH, dateDividers.BAR).split("/");
    let to = reverseMaskDate(this.state.dateTo, dateDividers.DASH, dateDividers.BAR).split("/");
    let buildFilterParams = {};

    if (from[2] && from[2].length < 4) {
      this.setState({ isDateFromValid: false });
      return;
    }
    if (
      new Date(`${from[1]}/${from[0]}/${from[2]}`).toString() ===
        "Invalid Date" &&
      !_.isEmpty(this.state.dateFrom)
    ) {
      this.setState({ isDateFromValid: false });
      return;
    } else {
      this.setState({ isDateFromValid: true });
    }

    if (to[2] && to[2].length < 4) {
      this.setState({ isDateToValid: false });
      return;
    }
    if (
      new Date(`${to[1]}/${to[0]}/${to[2]}`).toString() === "Invalid Date" &&
      !_.isEmpty(this.state.dateTo)
    ) {
      this.setState({ isDateToValid: false });
      return;
    } else {
      this.setState({ isDateToValid: true });
    }

    if (!_.isEmpty(this.state.tipoGuia))
      buildFilterParams.tipoGuia = this.state.tipoGuia.value;
    !_.isEmpty(this.state.dateFrom)
      ? (buildFilterParams.periodoInicial = new Date(
          `${from[1]}/${from[0]}/${from[2]}`
        ))
      : (buildFilterParams.periodoInicial = null);
    !_.isEmpty(this.state.dateTo)
      ? (buildFilterParams.periodoFinal = new Date(
          `${to[1]}/${to[0]}/${to[2]}`
        ))
      : (buildFilterParams.periodoFinal = null);

    this.props.applyFilter(buildFilterParams);
  };

  focus = () => {
    setTimeout(() => {
      if (this.textInput) this.textInput.focus();
    }, 1000);
  };

  render() {
    return (
      <div>
        <Form>
          <div id="label-buscar">
            {m.TELA_GERACAO_LOTE_COBRANCA.LABEL_BUSCAR_POR}
          </div>

          <Form.Group id="form-group">
            <Form.Field inline={true} width={4}>
              <div className="form-input-label">
                {m.TELA_GERACAO_LOTE_COBRANCA.LABEL_TIPO_GUIA}
              </div>
              <Select
                name="tipoGuia"
                id="consulta-disabled"
                value={this.state.tipoGuia}
                onChange={this.handleInputStateValue}
                placeholder=""
                isDisabled={true}
                ref={(input) => {
                  this.textInput = input;
                }}
                styles={
                  this.state.conselhoSelecionado || !this.state.hasSubmitted
                    ? selectFieldStyle
                    : selectFieldStyleError
                }
                inputValue=""
                options={this.tiposGuia}
              />
              <ErrorMsgLabel
                boolean={false}
                message={
                  m.TELA_GERACAO_LOTE_COBRANCA.MENSAGEM_CAMPO_OBRIGATORIO
                }
              />
            </Form.Field>
            <Form.Field inline={true} width={8}>
              <div className="form-input-label">
                {m.TELA_GERACAO_LOTE_COBRANCA.LABEL_FILTRAR_PERIODO_DE_TEMPO}
              </div>
              <Grid columns="equal" className="grid-margin-0">
                <Grid.Column width={1}>
                  <div className="form-input-label date-from-label"> de </div>
                </Grid.Column>
                <Grid.Column width={7}>
                  <Input
                    type="date"
                    style={{ width: "100%" }}
                    name="dateFrom"
                    value={this.state.dateFrom}
                    onChange={this.dateChange}
                    className={this.state.isDateFromValid ? "" : "error"}
                    closable={true}
                    iconPosition="left"
                  />
                  <ErrorMsgLabel
                    boolean={!this.state.isDateFromValid}
                    message={
                      m.TELA_GERACAO_LOTE_COBRANCA.MENSAGEM_DATA_INVALIDA
                    }
                  />
                </Grid.Column>
                <Grid.Column width={1}>
                  <div className="form-input-label date-to-label"> a </div>
                </Grid.Column>
                <Grid.Column width={7}>
                  <Input
                    type="date"
                    style={{ width: "100%" }}
                    name="dateTo"
                    value={this.state.dateTo}
                    onChange={this.dateChange}
                    className={this.state.isDateToValid ? "" : "error"}
                    closable={true}
                    iconPosition="left"
                  />
                  <ErrorMsgLabel
                    boolean={!this.state.isDateToValid}
                    message={
                      m.TELA_GERACAO_LOTE_COBRANCA.MENSAGEM_DATA_INVALIDA
                    }
                  />
                </Grid.Column>
              </Grid>
            </Form.Field>
            <Form.Field inline={true} width={4}>
              <Button
                className="button-filtrar-cobranca"
                onClick={this.handleSubmit}
              >
                {m.TELA_GERACAO_LOTE_COBRANCA.LABEL_FILTRAR} (ENTER)
              </Button>
            </Form.Field>
          </Form.Group>
        </Form>
        <CustomSnackbar
          setClick={(click) => (this.exibirSnackBar = click)}
          variant="warning"
          duration={2000}
          content={this.state.snackBarMessage}
        />
      </div>
    );
  }
}

export default FormFiltro;
